export default __webpack_public_path__ + "static/media/personalwebsite.58a1c7be.png";